document.addEventListener("DOMContentLoaded", function() {

    // --- CONFIGURATION ---
    // We added 'provisions-three' based on your logs
    const TARGET_SUFFIXES = ['provisions', 'provisions-product', 'january-beef-share', 'provisions-three'];

    // 1. Check if we are on the right page
    const currentSuffix = getTemplateSuffix();

    if (TARGET_SUFFIXES.indexOf(currentSuffix) !== -1) {
        initAppstleEnhancements();
    }

    // --- HELPER FUNCTIONS ---

    function getTemplateSuffix() {
        var body = document.body;
        if (!body) return '';

        // 1. Try the data attribute
        var suffix = body.getAttribute('data-template-suffix');
        if (suffix && String(suffix).length) return String(suffix);

        // 2. Fallback to class parsing (This is what worked in your logs)
        var className = body.className || '';
        var match = className.match(/template-[^.\s]+\.([^\s]+)/);
        if (match && match[1]) return match[1];

        return '';
    }

    function initAppstleEnhancements() {
        const CHECK_INTERVAL = 100;
        const MAX_ATTEMPTS = 50; // 5 seconds max
        let attempts = 0;
        let hasAutoSelected = false;

        const appstleWatcher = setInterval(() => {
            attempts++;

            // Look for the Subscription Wrapper (The one with the dropdown)
            const subWrapper = document.querySelector('.appstle_subscription_wrapper_option.appstle_include_dropdown');

            if (subWrapper) {
                const subRadio = subWrapper.querySelector('input[type="radio"]');

                // A. Force Selection
                // Only click if it exists and isn't already checked
                if (subRadio && !hasAutoSelected) {
                    if (!subRadio.checked) {
                        subRadio.click();
                    }
                    hasAutoSelected = true;
                }

                // B. Inject Perks Text
                // Finds the label container to append the text nicely
                const labelContainer = subWrapper.querySelector('.appstle_radio_label');

                if (labelContainer && !document.getElementById('sub-perks-msg')) {
                    const perks = document.createElement('div');
                    perks.id = 'sub-perks-msg';
                    // Inline styles to ensure it looks good immediately
                    perks.style.cssText = "font-size: 12px; color: #666; margin-top: 4px; margin-left: 28px; line-height: 1.4; font-weight: normal;";
                    perks.innerHTML = "✓ Seasonally Rotating Products<br>✓ Pause or cancel easily";
                    labelContainer.appendChild(perks);
                }

                // Cleanup: If we did our job, stop the interval
                if (hasAutoSelected && document.getElementById('sub-perks-msg')) {
                    clearInterval(appstleWatcher);
                }
            }

            // Safety: Stop looking after 5 seconds if Appstle never loads
            if (attempts >= MAX_ATTEMPTS) {
                clearInterval(appstleWatcher);
            }
        }, CHECK_INTERVAL);
    }
});